<section class="grid-container">
    <div class="grid-title">
        <span class="dx-form-group-caption">{{title}}</span>
    </div>
    <ng-content select="dx-tree-list"></ng-content>
    <dx-button class="add-new-button" [text]='"Add new"' *ngIf="showAdd" stylingMode="outlined" type="default" icon="add" (onClick)="onAddClicked($event)"> </dx-button>
</section>
